import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { TextField, DatePicker, TimePicker, SelectField, AutoComplete } from 'redux-form-material-ui';
import Paper from 'material-ui/Paper';
import MenuItem from 'material-ui/MenuItem';
import MUIAutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'lodash';

class OrderForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    locations: PropTypes.any.isRequired,
  }
  static validate = (values) => {
    const errors = {};
    const requiredFields = ['fromLocation','toLocation','reference','weight','pieces','serviceLevel'];

    requiredFields.forEach((item) => {
      if (!values[item]) {
        errors[item] = 'Required';
      }
    });
    
    return errors;
  }

  constructor(props) {
    super(props);

    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);

    this.state = {
      courier: false,
      from: {},
      toAdd: {},
    }
  }

  handleCodeChange = (event, index, oldValue) => {
    this.setState({ courier: (index <= 3) });
  }

  handleFromChange = (value) => {
    const { locations } = this.props;
    const locs = _.filter(locations.list, (item) => {
      return item.name === value;
    });
    this.setState({
      from: locs.pop(),
    });
  }

  handleToChange = (value) => {
    const { locations } = this.props;
    const locs = _.filter(locations.list, (item) => {
      return item.name === value;
    });
    this.setState({
      toAdd: locs.pop(),
    });
  }

  renderTextField = props => {
    const { initValue, ...newProps } = props;
    return (<TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...newProps} value={initValue} />);
  };

  parseAddress = (addressStr) => {
    const address = {};
    let stateAndZip;
    const a = addressStr.split(',');
    if (a.length === 4) {
      address.street = a[0].trim();
      address.city = a[1].trim();
      stateAndZip = a[2].trim().split(' ');
      address.state = stateAndZip[0];
      address.zip = stateAndZip[1];
      address.country = a[3].trim();
    } else if (a.length === 5) {
      address.street = a[0].trim();
      address.street2 = a[1].trim();
      address.city = a[2].trim();
      stateAndZip = a[3].trim().split(' ');
      address.state = stateAndZip[0];
      address.zip = stateAndZip[1];
      address.country = a[4].trim();
    }
    return address;
  }

  render() {
    const { from, toAdd } = this.state;
    const { handleSubmit, submitting, locations } = this.props;
    const locs = locations.list.map((loc) => {
      return loc.name;
    });

    let fromAddress;
    let toAddress;

    if (from && from.address) {
      fromAddress = this.parseAddress(from.address.address);
    }
    if (toAdd && toAdd.address) {
      toAddress = this.parseAddress(toAdd.address.address);
    }

    const buttonText = (submitting) ? 'Saving...' : 'Place Order';

    const isDispatch = false;
    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col s12 m6">
            <Paper zDepth={1} style={{padding: '20px'}}>
              <h4 style={{ textAlign: 'left' }}>From</h4>
              <div className="row">
                <div className="col s12">
                  <Field name="fromLocation" component={AutoComplete} dataSource={locs} filter={MUIAutoComplete.fuzzyFilter} floatingLabelText="From" onNewRequest={this.handleFromChange} fullWidth />
                </div>
              </div>
              <div className="row">
                <div className="col s12">
                  <Field name="fromAddress" component={this.renderTextField} floatingLabelText="Address" fullWidth initValue={fromAddress ? fromAddress.street : ''} disabled/>
                </div>
              </div>
              <div className="row">
                <div className="col s6">
                  <Field name="fromCity" component={this.renderTextField} floatingLabelText="City" fullWidth initValue={fromAddress ? fromAddress.city : ''} disabled />
                </div>
                <div className="col s3">
                  <Field name="fromState" component={this.renderTextField} floatingLabelText="State" fullWidth initValue={fromAddress ? fromAddress.state : ''} disabled />
                </div>
                <div className="col s3">
                  <Field name="fromZip" component={this.renderTextField} floatingLabelText="Zip" fullWidth initValue={fromAddress ? fromAddress.zip : ''} disabled />
                </div>
              </div>
            </Paper>
          </div>
          <div className="col s12 m6">
            <Paper zDepth={1} style={{padding: '20px'}}>
              <h4 style={{ textAlign: 'left' }}>To</h4>
              <div className="row">
                <div className="col s12">
                  <Field name="toLocation" component={AutoComplete} dataSource={locs} filter={MUIAutoComplete.fuzzyFilter} floatingLabelText="To" onNewRequest={this.handleToChange} fullWidth />
                </div>
              </div>
              <div className="row">
                <div className="col s12">
                  <Field name="toAddress" component={this.renderTextField} floatingLabelText="Address" fullWidth initValue={toAddress ? toAddress.street : ''} disabled />
                </div>
              </div>
              <div className="row">
                <div className="col s6">
                  <Field name="toCity" component={this.renderTextField} floatingLabelText="City" fullWidth  initValue={toAddress ? toAddress.city : ''} disabled />
                </div>
                <div className="col s3">
                  <Field name="toState" component={this.renderTextField} floatingLabelText="State" fullWidth  initValue={toAddress ? toAddress.state : ''} disabled />
                </div>
                <div className="col s3">
                  <Field name="toZip" component={this.renderTextField} floatingLabelText="Zip" fullWidth  initValue={toAddress ? toAddress.zip : ''} disabled />
                </div>
              </div>
            </Paper>
          </div>
        </div>
        <div className="row">
          <div className="col s12 m4">
            <Field name="serviceLevelId" component={SelectField} floatingLabelText="Service Type" fullWidth>
              <MenuItem value={1} primaryText="Next Day" />
              <MenuItem value={2} primaryText="2nd Day" />
              <MenuItem value={3} primaryText="Next Available" />
              <MenuItem value={4} primaryText="Expedited" />
            </Field>
          </div>
          {isDispatch &&
          <div className="col s12 m4">
            <Field name="codeId" component={SelectField} floatingLabelText="Type" onChange={this.handleCodeChange} fullWidth>
              <MenuItem value={1} primaryText="L1" />
              <MenuItem value={2} primaryText="L2" />
              <MenuItem value={3} primaryText="L3" />
              <MenuItem value={4} primaryText="L4" />
            </Field>
          </div>
          }
          <div className="col s12 m4" />
        </div>
        {isDispatch &&
          <div className="row">
            <div className="col s12 m6">
              <div className="row">
                <div className="col s12 m6">
                  <Field name="pickupDate" component={DatePicker} floatingLabelText="Pickup Date" fullWidth value={null}/>
                </div>
                <div className="col s12 m6">
                  <Field name="pickupTime" component={TimePicker} floatingLabelText="Pickup Time" fullWidth value={null}/>
                </div>
              </div>
            </div>
            <div className="col s12 m6">
              <div className="row">
                <div className="col s12 m6">
                  <Field name="deliveryDate" component={DatePicker} floatingLabelText="Delivery Date" fullWidth value={null}/>
                </div>
                <div className="col s12 m6">
                  <Field name="deliveryTime" component={TimePicker} floatingLabelText="Delivery Time" fullWidth value={null}/>
                </div>
              </div>
            </div>
          </div>
        }
        <div className="row">
          <div className="col s12 m4">
            <Field name="reference" type="text" component={this.renderTextField} floatingLabelText="Reference/PO" fullWidth />
          </div>
          <div className="col s12 m4">
            <Field name="weight" type="text" component={this.renderTextField} floatingLabelText="Weight" fullWidth />
          </div>
          <div className="col s12 m4">
            <Field name="pieces" type="text" component={this.renderTextField} floatingLabelText="Pieces" fullWidth />
          </div>
        </div>
        <div className="row">
          <div className="col s12 m8"></div>
          <div className="col s12 m4">
            <RaisedButton onClick={handleSubmit} fullWidth primary style={{color:'#fff'}}>{buttonText}</RaisedButton>
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'orderForm',
  validate: OrderForm.validate
})(OrderForm);





// WEBPACK FOOTER //
// ./src/components/Orders/Edit.js